import {
  uaLimitedReleaseDetailConstants,
  createUALimitedReleaseDetailConstants,
  editUALimitedReleaseDetailConstants,
  addTargetUALimitedReleaseDetailConstants,
  removeTargetUALimitedReleaseDetailConstants,
  activateUALimitedReleaseDetailConstants,
  deactivateUALimitedReleaseDetailConstants,
  deleteUALimitedReleaseDetailConstants,
} from "../_redux-constants";

export function uaLimitedReleasesDetailReducer(
  state = {
    uaLimitedReleaseDetailLoading: false,
    uaLimitedReleaseDetailData: null,
    uaLimitedReleaseDetailError: null,

    createUALimitedReleaseDetailLoading: false,
    createUALimitedReleaseDetailData: null,
    createUALimitedReleaseDetailError: null,

    editUALimitedReleaseDetailLoading: false,
    editUALimitedReleaseDetailData: null,
    editUALimitedReleaseDetailError: null,

    addTargetUALimitedReleaseDetailLoading: false,
    addTargetUALimitedReleaseDetailData: null,
    addTargetUALimitedReleaseDetailError: null,

    removeTargetUALimitedReleaseDetailLoading: false,
    removeTargetUALimitedReleaseDetailData: null,
    removeTargetUALimitedReleaseDetailError: null,

    activateUALimitedReleaseDetailLoading: false,
    activateUALimitedReleaseDetailData: null,
    activateUALimitedReleaseDetailError: null,

    deactivateUALimitedReleaseDetailLoading: false,
    deactivateUALimitedReleaseDetailData: null,
    deactivateUALimitedReleaseDetailError: null,

    deleteUALimitedReleaseDetailLoading: false,
    deleteUALimitedReleaseDetailData: null,
    deleteUALimitedReleaseDetailError: null,
  },
  action
) {
  switch (action.type) {
    case uaLimitedReleaseDetailConstants.UA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        uaLimitedReleaseDetailLoading: true,
        uaLimitedReleaseDetailData: null,
        uaLimitedReleaseDetailError: null,
      });
    case uaLimitedReleaseDetailConstants.UA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        uaLimitedReleaseDetailLoading: false,
        uaLimitedReleaseDetailData: action.data,
      });
    case uaLimitedReleaseDetailConstants.UA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        uaLimitedReleaseDetailLoading: false,
        uaLimitedReleaseDetailData: null,
        uaLimitedReleaseDetailError: action.error,
      });
    case createUALimitedReleaseDetailConstants.CREATE_UA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        createUALimitedReleaseDetailLoading: true,
        createUALimitedReleaseDetailData: null,
        createUALimitedReleaseDetailError: null,
      });
    case createUALimitedReleaseDetailConstants.CREATE_UA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        createUALimitedReleaseDetailLoading: false,
        createUALimitedReleaseDetailData: action.data,
      });
    case createUALimitedReleaseDetailConstants.CREATE_UA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        createUALimitedReleaseDetailLoading: false,
        createUALimitedReleaseDetailData: null,
        createUALimitedReleaseDetailError: action.error,
      });
    case editUALimitedReleaseDetailConstants.EDIT_UA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        editUALimitedReleaseDetailLoading: true,
        editUALimitedReleaseDetailData: null,
        editUALimitedReleaseDetailError: null,
      });
    case editUALimitedReleaseDetailConstants.EDIT_UA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        editUALimitedReleaseDetailLoading: false,
        editUALimitedReleaseDetailData: action.data,
      });
    case editUALimitedReleaseDetailConstants.EDIT_UA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        editUALimitedReleaseDetailLoading: false,
        editUALimitedReleaseDetailData: null,
        editUALimitedReleaseDetailError: action.error,
      });
    case addTargetUALimitedReleaseDetailConstants.ADD_TARGET_UA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        addTargetUALimitedReleaseDetailLoading: true,
        addTargetUALimitedReleaseDetailData: null,
        addTargetUALimitedReleaseDetailError: null,
      });
    case addTargetUALimitedReleaseDetailConstants.ADD_TARGET_UA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        addTargetUALimitedReleaseDetailLoading: false,
        addTargetUALimitedReleaseDetailData: action.data,
      });
    case addTargetUALimitedReleaseDetailConstants.ADD_TARGET_UA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        addTargetUALimitedReleaseDetailLoading: false,
        addTargetUALimitedReleaseDetailData: null,
        addTargetUALimitedReleaseDetailError: action.error,
      });
    case removeTargetUALimitedReleaseDetailConstants.REMOVE_TARGET_UA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        removeTargetUALimitedReleaseDetailLoading: true,
        removeTargetUALimitedReleaseDetailData: null,
        removeTargetUALimitedReleaseDetailError: null,
      });
    case removeTargetUALimitedReleaseDetailConstants.REMOVE_TARGET_UA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        removeTargetUALimitedReleaseDetailLoading: false,
        removeTargetUALimitedReleaseDetailData: action.data,
      });
    case removeTargetUALimitedReleaseDetailConstants.REMOVE_TARGET_UA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        removeTargetUALimitedReleaseDetailLoading: false,
        removeTargetUALimitedReleaseDetailData: null,
        removeTargetUALimitedReleaseDetailError: action.error,
      });
    case activateUALimitedReleaseDetailConstants.ACTIVATE_UA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        activateUALimitedReleaseDetailLoading: true,
        activateUALimitedReleaseDetailData: null,
        activateUALimitedReleaseDetailError: null,
      });
    case activateUALimitedReleaseDetailConstants.ACTIVATE_UA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        activateUALimitedReleaseDetailLoading: false,
        activateUALimitedReleaseDetailData: action.data,
      });
    case activateUALimitedReleaseDetailConstants.ACTIVATE_UA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        activateUALimitedReleaseDetailLoading: false,
        activateUALimitedReleaseDetailData: null,
        activateUALimitedReleaseDetailError: action.error,
      });
    case deactivateUALimitedReleaseDetailConstants.DEACTIVATE_UA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        deactivateUALimitedReleaseDetailLoading: true,
        deactivateUALimitedReleaseDetailData: null,
        deactivateUALimitedReleaseDetailError: null,
      });
    case deactivateUALimitedReleaseDetailConstants.DEACTIVATE_UA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        deactivateUALimitedReleaseDetailLoading: false,
        deactivateUALimitedReleaseDetailData: action.data,
      });
    case deactivateUALimitedReleaseDetailConstants.DEACTIVATE_UA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        deactivateUALimitedReleaseDetailLoading: false,
        deactivateUALimitedReleaseDetailData: null,
        deactivateUALimitedReleaseDetailError: action.error,
      });
    case deleteUALimitedReleaseDetailConstants.DELETE_UA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        deleteUALimitedReleaseDetailLoading: true,
        deleteUALimitedReleaseDetailData: null,
        deleteUALimitedReleaseDetailError: null,
      });
    case deleteUALimitedReleaseDetailConstants.DELETE_UA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        deleteUALimitedReleaseDetailLoading: false,
        deleteUALimitedReleaseDetailData: action.data,
      });
    case deleteUALimitedReleaseDetailConstants.DELETE_UA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        deleteUALimitedReleaseDetailLoading: false,
        deleteUALimitedReleaseDetailData: null,
        deleteUALimitedReleaseDetailError: action.error,
      });
    default:
      return state;
  }
}
